import { render } from "./OrdineAsporto.vue?vue&type=template&id=0e011300&scoped=true"
import script from "./OrdineAsporto.vue?vue&type=script&lang=js"
export * from "./OrdineAsporto.vue?vue&type=script&lang=js"

import "./OrdineAsporto.vue?vue&type=style&index=0&id=0e011300&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e011300"]])

export default __exports__